export default "__VITE_ASSET__vGjhkCx6__"